import Cookies from "js-cookie";
import { AUTH_TOKEN } from "../constants/constants";
import { jwtDecode } from "jwt-decode";

export const getCookieUsuari = () => {
  return Cookies.get("Usuari");
};

export const getAuthToken = () => {
  return Cookies.get(AUTH_TOKEN) || "";
};

export const removeAuthToken = () => {
  Cookies.remove(AUTH_TOKEN);
};


export function decodeToken(token) {
	return jwtDecode(token)
}

export function hasTokenExpired(token) {
	const decodedToken = decodeToken(token)
	const expirationTimeInSeconds = decodedToken.exp
	const currentTimeInSeconds = Date.now() / 1000
	return expirationTimeInSeconds < currentTimeInSeconds
}

export function isValidToken(token) {
	if (!token) {
		return false
	}

	const tokenHasExpired = hasTokenExpired(token)
	return !tokenHasExpired
}